<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center >
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-btn to="/tickets" rounded class="btn-exit">
              <v-icon>mdi-backspace-reverse-outline</v-icon>
              بازگشت
            </v-btn>
            <v-card class="m-20">
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->

                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>

                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg12 xl12 class="p-2">
                    <v-text-field
                        readonly
                        v-model="title"
                        label="عنوان تیکت"
                        required
                        outlined

                    ></v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">


                    <!--                    <v-select-->
                    <!--                        v-model="roleid"-->
                    <!--                        :rules="rules.status"-->
                    <!--                        :items="roles"-->
                    <!--                        item-text="name_fa"-->
                    <!--                        item-value="id"-->
                    <!--                        :error-messages="errors.role_id"-->
                    <!--                        label="انتخاب نقش"-->
                    <!--                        outlined-->
                    <!--                        dense-->
                    <!--                        return-object></v-select>-->



                    <v-select
                        v-model="selectedDepartment"
                        :items="departments"
                        item-text="title"
                        v-on:change="notifyStatus"
                        item-value="id"
                        outlined
                        label="دپارتمان"
                    >
                    </v-select>
                  </v-flex>



                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">

                    <!--  <p>اولویت بندی</p>-->

                    <v-btn-toggle
                        class="mr-8"
                        v-model="importance"
                        shaped
                        color="#3294AA"
                        mandatory
                    >
                      <v-btn value="3">
                        معمولی
                      </v-btn>

                      <v-btn value="2">
                        مهم
                      </v-btn>

                      <v-btn value="1">
                        بسیار مهم
                      </v-btn>


                    </v-btn-toggle>

                  </v-flex>
                </v-row>



                <v-row>
                <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" align-self-center>
                  <v-row class="-align-center">
                    <v-card-title>وضعیت</v-card-title>
                  <v-radio-group
                      v-model="ticketState"
                      row
                  >
                    <v-radio
                        label="باز"
                        value="open"
                    ></v-radio>
                    <v-radio
                        label="بسته"
                        value="closed"
                    ></v-radio>
                  </v-radio-group>
                  </v-row>
                  </v-flex>


                </v-row>




                <v-row class="mt-2">
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="notify">

                    <!--                    <ckeditor v-if="ckEditor"-->
                    <!--                              :editor="editor.editor" v-model="text" :config="editor.editorConfig"></ckeditor>-->
                  </v-flex>
                  <v-textarea v-model="text" dense outlined label="متن پیام"  readonly></v-textarea>

                </v-row>






                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 >
                    <v-file-input
                        label="پیوست فایل"
                        outlined
                    ></v-file-input>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-btn @click="updateTicket" :loading="loading" color="#50858B"  class="text-white p-6 ml-30"
                    >
                      <v-icon class="ml-4">mdi-content-save</v-icon>
                     ذخیره
                    </v-btn>
                  </v-flex>
                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import error from "@/view/pages/error/Error";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  props: ['id'],
  data() {
    return {
      loading: false,
      title: '',
      notify: false,
      text: '',
      ticketState:null,
      ckEditor: false,
      importance:'',
      departments:[],
      selectedDepartment:null,
      textArea: true,
      notify_type: 'sms',
      status_types: [
        {name: 'info', value: 'اطلاع رسانی'},
        {name: 'success', value: 'موفقیت'},
        {name: 'warning', value: 'هشدار'},
        {name: 'danger', value: 'خطر'}
      ],
      notify_types: [
        {name: 'sms', value: 'پیامک'},
        {name: 'email', value: 'ایمیل'},
        {name: 'notification', value: 'اطلاع رسانی'},
        {name: 'push_notification', value: 'اطلاع رسانی پنل'}
      ],
      cost: '',
      users: [],
      extras: {
        notify_at: '',
        status_type: '',
        icon: ''
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
    }
  },
  methods: {
    updateTicket() {
      this.loading = true;
      // window.alert(this.status)
      this.requestApiPost(`ticket/${this.id}`, {
        title: this.title,
        ticket_id: this.id,
        description: this.text,
        department_id:this.selectedDepartment,
        importance:this.importance,
        status:this.ticketState,
        _method: 'PUT'
      }).then((response) => {
        this.loading = false;
        this.$toast.success('تیکت با موفقیت ویرایش شد');
        this.$router.push({name: 'adminTickets.index'});
      }).catch(({response}) => {
        this.errors = response.data;
        console.log(response.data);
        this.loading = false;
      });
    },
    findNotification() {
       this.requestApiGet(`ticket/${this.id}`).then(({data}) => {
         this.title = data.title;
         this.selectedDepartment = data.department_id;
         this.importance = data.importance;
         this.ticketState = data.status;
         this.text = data.messages[0].description;
       }).catch((error) => {
         console.log(error);
       });
    },
    getDepartments() {
      this.requestApiGet('department',
      ).then(response => {
        this.departments = response.data.data;
      })
    },

    notifyStatus(data) {
      if (data.name === 'sms') {
        this.ckEditor = false;
        this.textArea = true;
      } else {
        this.textArea = false;
        this.ckEditor = true;
        this.cost = '';
      }
    }
  },

  created() {
    this.getDepartments()
    this.findNotification();
    this.$store.dispatch(SET_BREADCRUMB, [{name: this.$route.meta.title}])

  }
}
</script>